import React from 'react';
import { Container, Row } from 'react-bootstrap';
import i18n from 'I18n';
import Addition from 'assets/images/addition.svg';
import Subtraction from 'assets/images/subtraction.svg';


const QuantitySelector = ({
  language,
  isConfirm,
  count,
  btnMinusDisable,
  btnAddDisable,
  countMinus,
  countAdd,
}) => {
  if (isConfirm) {
    return (
      <div className='quantity_selector_container'>
        <Row>
          <label className="block_label headline">{i18n.t('campaign_quantity')}</label>
        </Row>
        <div>
          <label className="numbers title-large">{count}</label>
        </div>
      </div>
    )
  }

  return (
    <div className='quantity_selector_container'>
      <Row>
        <label className="block_label headline">{i18n.t('campaign_quantity')}</label>
      </Row>
      <Row className="quantity_row">
        <button
          className="reduce_btn"
          onClick={countMinus}
          disabled={btnMinusDisable}
        >
          <img
            alt="minus"
            src={Subtraction}
            className="icon"
          ></img>
        </button>
        <label className="numbers title-large">{count}</label>
        <button
          className="multiply_btn justify-content-end"
          onClick={countAdd}
          disabled={btnAddDisable}
        >
          <img
            alt="multiply"
            src={Addition}
            className="icon"
          />
        </button>
      </Row>
    </div>
  )
};

export default QuantitySelector;
